<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zasR7k/tc-custom/9781614233749.jpg?1736601373574" alt="This image is the cover for the book Haunted Birmingham, Haunted America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Haunted Birmingham, Haunted America
      </h1>
      <p class="bookDescription body article font2">
        <b>A supernatural tour of Alabama’s biggest city, filled with local legends and Southern folklore . . . Photos included!</b><br/>  <br/> From the eerie vestiges of the Sloss Furnaces to the unexplained (and un-booked) performances in the Alabama Theatre and the rather otherworldly room service at the Tutwiler Hotel, Birmingham is truly one of the South’s supernatural hotbeds.<br/>  <br/> Renowned author and ghost expert Alan Brown delivers a fascinating, downright spine-chilling collection of haunts from around the city and surrounding neighborhoods such as Bessemer, Columbiana, Jasper, and Montevallo. Residents and tourists alike will cherish this glimpse into the city’s inexplicable occupants, and the lively history behind the legends.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alan Brown
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?539a612b